import { graphql, useStaticQuery } from "gatsby";
    import { PatstoreContent } from '@types';

const useGetContent = () => {
    const data = useStaticQuery(graphql`
        query AllContent {
            allPatstoreContent {
                edges {
                    node {
                        id
                        
            objectId
    categories
    label
    title
    createdAt
    text
    gallery
    data
    state
    content_id
    active
    
                    }
                }
            }
        }
    
        `);


    const allContent: PatstoreContent[] =
        data.allPatstoreContent.edges.map(
            (edge: { node: PatstoreContent }) => edge.node
        ) || [];

    const findContent: (id: string) => PatstoreContent | undefined = (id: string) => {
        const result = allContent.find((item: PatstoreContent) => item.objectId === id);

        if (!result) {
            return undefined;
        }

        return result;
    };

    return {
        findContent,
        contents: allContent,
    };
}; 

export default useGetContent;
